import { GetGatewayConfigs } from '@/generated/graphql';

type TenantConfigs = GetGatewayConfigs['tenant']['tenantConfiguration'] & {
  graphiteEnabled: GetGatewayConfigs['tenant']['graphiteEnabled'];
};

export type GatewayConfigs = GetGatewayConfigs['gatewayConfigs'] & TenantConfigs & { __typename?: string };

export const DEFAULT_GATEWAY_CONFIGS: GatewayConfigs = {
  returnedSeriesLimit: 0,
  returnedDatapointsLimit: 0,
  tracingUIEnabled: false,
  collectionsAccess: 'disabled',
  serviceUIEnabled: false,
  sloUIEnabled: false,
  scrapeInterval: '15s',
  enableExternalServiceConfig: false,
  enableMetricsDDX: false,
  alertEntityUIEnabled: false,
  aiGatewayEnabled: false,
  agentInvestigationsEnabled: false,
  graphiteEnabled: false,
};
